import script from "./Articles.vue?vue&type=script&setup=true&lang=js"
export * from "./Articles.vue?vue&type=script&setup=true&lang=js"

import "./Articles.vue?vue&type=style&index=0&id=40870ee0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40870ee0"]])

export default __exports__